import { render, staticRenderFns } from "./BumpsTemplate.vue?vue&type=template&id=09ac0164"
import script from "./BumpsTemplate.vue?vue&type=script&lang=js"
export * from "./BumpsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports